<template>
  <div class="login">
    <div class="box clear" id="login">
      <div class="tab">
        <div class="title mb20">
          <span @click="tabChange(true)" :class="passwordLogin? 'active': ''">手机登录</span>
          <span @click="tabChange(false)" :class="passwordLogin? '': 'active'">已有账号？去登录</span>
        </div>
        <el-form ref="formCustom" label-position="left" :model="formCustom" v-if="codeLogin">
          <el-form-item prop="mobile">
            <el-input type="number" placeholder="请输入手机号" v-model="formCustom.mobile"></el-input>
          </el-form-item>
          <el-form-item prop="passwd">
            <el-input type="password" placeholder="请输入密码" v-model="formCustom.passwd"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn_register" style="width: 100%;" type="primary" @click="handleSubmit">登录</el-button>
          </el-form-item>
        </el-form>
        <el-form ref="formCustom" label-position="left" :model="formCustom" v-if="passwordLogin">
          <el-form-item prop="mobile">
            <el-input type="number" placeholder="请输入手机号" v-model="formCustom.mobile"></el-input>
          </el-form-item>
          <el-form-item prop="passwd">
            <el-input type="text" class="captcha" placeholder="请输入图片验证码" v-model="formCustom.captcha"></el-input>
            <img :src="captchaPath" class="login-captcha" @click="getCaptcha" alt="">
          </el-form-item>
          <el-form-item prop="passwd">
            <el-input type="number" class="input-code" placeholder="请输入手机验证码" v-model="formCustom.code"></el-input>
            <div class="btn-code">
                <el-button type="primary" v-if="showCode" @click="codeSubmit">获取验证码</el-button>
                <el-button type="primary" disabled v-if="!showCode" class="count">{{countCode}}s重新获取</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="btn_register" style="width: 100%;" type="primary" @click="btnCode">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="btnRegister">
          <router-link to='/register'>还没账号？点击注册</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../axios'
import { getUUID, clearLoginInfo } from '@/utils'
import httpRequest from '@/utils/httpRequest'
export default {
  inject: ['reload'],
  data () {
    return {
      formCustom: {
        mobile: '',
        passwd: '',
        code: '',
        captcha: '',
        uuid: ''
      },
      passwordLogin: false,
      codeLogin: true,
      showCode: true,
      countCode: '',
      timerCode: null,
      mobileCode: '',
      captchaPath: '',
      showHeaderUserInfo: false
    }
  },
  methods: {
    localStorage (data) {
      const obj = {
        username: data.user.mobile,
        userId: data.user.userId,
        type: data.user.type
      }
      localStorage.setItem('info', JSON.stringify(obj))
    },
    handleSubmit () {
      if (this.formCustom.mobile === '') {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        })
        return
      }
      if (!(/^1[3456789]\d{9}$/.test(this.formCustom.mobile))) {
        this.$message({
          type: 'error',
          message: '手机号码有误，请重填'
        })
        return
      }
      if (this.formCustom.passwd === '') {
        this.$message({
          type: 'error',
          message: '请输入密码'
        })
        return
      }
      const that = this
      let pam = {
        mobile: this.formCustom.mobile,
        password: this.formCustom.passwd,
        type: 1
      }
      try {
        http.login(pam).then(({data}) => {
          switch (data.code) {
            case 0:
              that.$message({
                type: 'success',
                message: '登录成功',
                offset: 50
              })
              that.localStorage(data)
              localStorage.setItem('token', data.user.token)
              that.$router.push({
                path: '/home'
              })
              that.$root.eventHub.$emit('headerEmit', that.showHeaderUserInfo)
              break
            case 601:
              that.$message({
                type: 'info',
                message: data.msg
              })
              break
            case 602:
              that.$message({
                type: 'info',
                message: data.msg
              })
              break
            default:
              that.$message({
                type: 'error',
                message: data.msg
              })
              break
          }
        })
      } catch (e) {
        that.$message.error(e)
      }
    },

    tabChange (b) {
      this.passwordLogin = b
      this.codeLogin = !b
    },
    codeSubmit () {
      if (this.formCustom.mobile === '') {
        this.$message.error('请输入手机号')
        return
      }
      if (!(/^1[3456789]\d{9}$/.test(this.formCustom.mobile))) {
        this.$message.error('手机号码有误，请重填')
        return
      }
      if (this.formCustom.captcha === '') {
        this.$message.error('请输入图片验证码')
        return
      };
      const that = this
      var param = {
        mobile: this.formCustom.mobile,
        picCode: this.formCustom.captcha,
        uuid: this.formCustom.uuid
      }
      try {
        http.getCode(param).then(({data}) => {
          switch (data.code) {
            case 0:
              that.$message.success('验证码已发送，请留意手机短信')
              that.mobileCode = data.mobileCode
              that.getNumCode()
              break
            case 2:
              that.$message.info('已超过短信发送次数!')
              break
            case 500:
              that.$message.info('图片验证码不正确!')
              break
            default:
              that.$message.error(data.msg)
          }
        })
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 获取验证码
    getNumCode () {
      const TIME_COUNT = 60
      if (!this.timerCode) {
        this.countCode = TIME_COUNT
        this.showCode = false
        this.timerCode = setInterval(() => {
          if (this.countCode > 0 && this.countCode <= TIME_COUNT) {
            this.countCode--
          } else {
            this.showCode = true
            clearInterval(this.timerCode)
            this.timerCode = null
          }
        }, 1000)
      }
    },
    // 获取图片验证码
    getCaptcha () {
      this.formCustom.uuid = getUUID()
      this.captchaPath = httpRequest.adornUrl(`/captcha.jpg?uuid=${this.formCustom.uuid}`)
    },
    btnCode () {
      if (this.formCustom.mobile === '') {
        this.$message.error('请输入手机号')
        return
      }
      if (!(/^1[3456789]\d{9}$/.test(this.formCustom.mobile))) {
        this.$message.error('手机号码有误，请重填')
        return
      }
      if (this.formCustom.code === '') {
        this.$message.error('请输入验证码')
        return
      }
      const that = this
      let pam = {
        mobile: this.formCustom.mobile,
        password: this.formCustom.code,
        type: 2,
        isAd: localStorage.getItem('isAd') || 'false',
        remote_referer: localStorage.getItem('remote_referer') || '',
        keywordUrl: localStorage.getItem('keywordUrl') || ''
      }
      try {
        http.login(pam).then(({data}) => {
          switch (data.code) {
            case 0:
              that.$message({
                type: 'success',
                message: '登录成功',
                offset: 50
              })
              that.localStorage(data)
              localStorage.setItem('token', data.user.token)
              that.$router.push({
                path: '/home'
              })
              if (data.user.loginAccount === 1) {
                that.$message({
                  showClose: true,
                  message: '初始密码为手机后六位数',
                  type: 'success'
                })
              }
              that.$root.eventHub.$emit('headerEmit', that.showHeaderUserInfo)
              that.getCaptcha()
              localStorage.removeItem('keywordUrl')
              localStorage.removeItem('remote_referer')
              localStorage.removeItem('isAd')
              break
            case 500:
              that.$message.info(data.msg)
              break
            case 601:
              that.$message.info(data.msg)
              break
            case 602:
              that.$Message.info(data.msg)
              break
            default:
              that.$message.error(data.msg)
              break
          }
        })
      } catch (e) {
        that.$message.error(e)
      }
    }
  },
  mounted () {
    clearLoginInfo()
    this.getCaptcha()
  }
}
</script>
<style scoped>
#login {
  background: url(../../assets/images/login/back.png) no-repeat;
    background-size: 100% 100%;
    width: 1200px;
    height: 460px;
}
.box .tab{
  width: 360px;
  float: right;
  padding: 20px 30px;
  margin-top: 50px;
  background: #fff;
  margin-right: 20px;
}
.title{
  display: flex;
  justify-content: space-between;
  padding: 10px 0;

}
.title span {
  display: inline-block;
  padding-bottom: 20px;
  text-align: center;
  cursor: pointer;
  border-bottom: 2px solid #999999;
}
.title span:first-child {
  width: 40%;
}
.title span:last-child {
  width: 60%;
}
.title .active {
  color: #FC6B0E;
  border-bottom: 2px solid #FC6B0E;
}
.captcha,
.input-code{
  width: 50%;
}
.login-captcha{
  width: 48%;
  float: none;
  height: 40px;
  vertical-align: middle;
}
.input-code {
  width: 50%;
}
.btn-code {
    width: 48%;
    float: right;
}
.btn-code button{
    display: inline-block;
    width: 100%;
    height: 40px;
    border: none;
    vertical-align: middle;
    padding: 0px 15px;
    background: #FC6B0E;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin-left: 2%;
    cursor: pointer;
}
.btn-code .count {
  background: #fff;
  color: #d2d2d2;
  border: 1px solid #d2d2d2;
  cursor: not-allowed;
}
.btnRegister {
  text-align: right;
  color: #29a7e1;
  margin-top: -10px;
}
.btn_register {
    background: #FC6B0E;
    border: 1px solid #FC6B0E;
    font-size: 16px;
    font-weight:bold;
    width: 100%;
    line-height: 20px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
}
.btnRegister a {
  color: #FC6B0E;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue